import { Check } from "lucide-react";

interface CheckoutProgressBarProps {
  currentStep: number;
}

export const CheckoutProgressBar = ({ currentStep }: CheckoutProgressBarProps) => {
  const steps = [
    { number: 1, label: "Gegevens" },
    { number: 2, label: "Betaling" },
    { number: 3, label: "Bevestiging" },
  ];

  return (
    <div className="w-full py-8">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between relative">
          {/* Progress Line */}
          <div className="absolute top-5 left-0 right-0 h-0.5 bg-muted -z-10">
            <div
              className="h-full bg-gold transition-all duration-500"
              style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
            />
          </div>

          {/* Steps */}
          {steps.map((step) => {
            const isCompleted = currentStep > step.number;
            const isCurrent = currentStep === step.number;
            
            return (
              <div key={step.number} className="flex flex-col items-center">
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300
                    ${isCompleted ? "bg-gold text-black" : ""}
                    ${isCurrent ? "bg-gold text-black ring-4 ring-gold/20" : ""}
                    ${!isCompleted && !isCurrent ? "bg-muted text-muted-foreground" : ""}
                  `}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    step.number
                  )}
                </div>
                <span
                  className={`
                    mt-2 text-sm font-medium transition-colors
                    ${isCurrent || isCompleted ? "text-gold" : "text-muted-foreground"}
                  `}
                >
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
